import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServicesPage.css';
import Breadcrumbs from '../components/Breadcrumbs';
import InHome1 from '../assets/Services/InHome.png';
import InHome5 from '../assets/Services/InHome_5.png';

const PrivateLessonsPage = () => (
  <div className='service-page container'>
    <Breadcrumbs />
    <h1>In-Home Lessons</h1>

    {/* Row 1 */}
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '40px',
        gap: '20px',
        padding: '0 40px 0 40px',
      }}
    >
      <div style={{ flex: '1 1 300px', textAlign: 'center' }}>
        <img
          src={InHome5}
          alt='Instructor and Student In Home Lessons'
          style={{
            width: '100%',
            borderRadius: '10px',
            height: 'auto',
          }}
        />
      </div>
      <div
        style={{
          flex: '2 1 400px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <p style={{ textAlign: 'center', lineHeight: '1.6' }}>
          Our private in-home lessons offer a personalized, one-on-one learning experience in the comfort of your own home. We currently provide in-home <b>guitar</b> and <b>drum</b> lessons, catering to students of all ages and skill levels. Whether you're picking up an instrument for the first time or looking to refine your technique, our professional tutors tailor each lesson to match your unique interests, goals, and experience level.
        </p>
      </div>
    </div>

    {/* Row 2 */}
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '40px',
        gap: '20px',
        padding: '0 40px 0 40px',
      }}
    >
      <div
        style={{
          flex: '2 1 400px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <p style={{ textAlign: 'center', lineHeight: '1.6' }}>
          Lessons are available in two convenient session lengths: <b>30-minute</b> and <b>45-minute</b> lessons. Our instructors focus on building strong foundational skills, developing technique, understanding music theory, and fostering creativity. Each lesson is designed to keep students engaged, motivated, and progressing at their own pace.
        </p>
      </div>
      <div style={{ flex: '1 1 300px', textAlign: 'center' }}>
        <img
          src={InHome1}
          alt='Instructor and Student In Home Lessons'
          style={{
            width: '100%',
            borderRadius: '10px',
            height: 'auto',
          }}
        />
      </div>
    </div>

    <p className='service-closing'>
      Our approach ensures that every student receives the support and guidance they need to grow as musicians, whether they want to play for fun, perform in a band, or prepare for professional opportunities. With a flexible curriculum, we incorporate each student’s favorite music styles and genres to make learning an exciting and rewarding experience!
    </p>
    <Link to='/contact' className='btn btn-primary'>Book a Private Lesson</Link>
  </div>
);

export default PrivateLessonsPage;
